import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

import {
  Card,
  CardContent,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { AppContext } from '@/AppContext';
import { shortenDate, shortenTime } from '../../../MeetupList/components/MeetupsTable/MeetupsTable';
import StatLogView from '../StatLogView/StatLogView';
import { CommentSharp } from '@mui/icons-material';

const PREFIX = 'StatLogTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
  logFilter: `${PREFIX}-logFilter`,
  toolbar: `${PREFIX}-toolbar`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {},

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },

  [`& .${classes.logFilter}`]: {
    width: 170,
    padding: '2px 4px',
  },

  [`& .${classes.toolbar}`]: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '20px 0',
  },
}));

const StatLogTable = props => {
  const { className, logFilter, setLogFilter, ...rest } = props;
  const appContext = useContext(AppContext);

  const filters = {
    all: 'Все действия',
    visitors: 'Посетители',
    meetups: 'Мероприятия',
    desks: 'Стойки',
    payments: 'Платежи',
  };

  const [data, setData] = useState([]);

  const [modal, setModal] = useState(undefined);
  useEffect(() => {
    appContext.accountApi
      .listStatLog(logFilter)
      .then(({ data }) => {
        setData(data.data);
      })
      .catch(appContext.errorHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logFilter]);

  const goBack = () => {
    appContext.history.push('/profile/log');
  };

  return (
    <Root>
      <div className={classes.toolbar}>
        <TextField
          select
          variant='standard'
          className={classes.logFilter}
          margin='dense'
          value={logFilter}
          onChange={e => setLogFilter(e.target.value)}
        >
          {Object.keys(filters).map(filter => (
            <MenuItem key={filter} value={filter}>
              {filters[filter]}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Время</TableCell>
                  <TableCell>Действие</TableCell>
                  <TableCell>Коммент</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((log, i) => (
                  <TableRow hover key={i} onClick={() => setModal(log)} style={{ cursor: 'pointer' }}>
                    <TableCell>
                      <ListItemText primary={shortenTime(log.timestamp)} />
                    </TableCell>
                    <TableCell>
                      <ListItemText primary={log.message.text} />
                    </TableCell>
                    <TableCell>
                      <ListItemText primary={log.comment} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
        {modal && <StatLogView data={modal} handleClose={() => setModal(undefined)} />}
      </Card>
    </Root>
  );
};

export default StatLogTable;
